export class Resolution {
  resolution_id: number;
  name: string;
  width: number;
  height: number;

  /**
   * Constructor
   *
   * @param resolution
   */
  constructor(resolution) {
    this.resolution_id = resolution.resolution_id || 0;
    this.name          = resolution.name          || '';
    this.width         = resolution.width         || '';
    this.height        = resolution.height        || '';
  }
}
